// Used to format date string from the server to display version start date and release date
// Server only stores date without any time information such as 2023-12-31
// Use this WHENEVER displaying version start date and release date.
// If you respect local timezone without this constant, there will be a bug that will display one day early date in negative timezones.
// https://jira.atlassian.com/browse/JSWCLOUD-22316
export const VERSION_DATE_FORMAT_OPTION = {
	day: 'numeric',
	month: 'short',
	year: 'numeric',
	timeZone: 'UTC',
} as const;
